import { Modal, Row, Col, Typography, Avatar, Image, Spin } from 'antd';
import { useAppDispatch, useAppSelector} from '../../../store/hooks/hooks';
import { selectSyncGeometrySelected, unselectSyncGeometry} from '../../../store/slice/mapSlice';
import { ReactComponent as SyncPoint } from '../../../res/svg/sync-point.svg';
import { ReactComponent as SyncPolygon } from '../../../res/svg/sync-polygon.svg';
import { ReactComponent as SyncLine } from '../../../res/svg/sync-line.svg';
import './SyncTaskPopup.less';
import { Line, Point, Polygon } from '../../../models/Geometries';
import { createInitialNames, truncateStringEllipsis } from '../../../utils/functions';
import moment from 'moment';
import { useState, useEffect } from 'react';
import { getAdjuntoFullSize, getAdjuntoThumbnail } from '../../../store/slice/adjuntosSlice';
import { LoadingOutlined } from '@ant-design/icons';
import { Adjuntos } from '../../../models/Adjuntos';
import { getCategoriaPunto } from '../../../utils/categorias_punto.constant';

/**
 * @component SyncTaskPopup.tsx
 * @description SyncTaskPopup component that show all attributes of one task finalized
 * @return { Component }
 */

/*
    componente que visualiza todos los datos de una geometria sincronizada en un popup
*/
function SyncTaskPopup() {
  const { Text } = Typography;
  const dispatch = useAppDispatch();
  const syncGeometrySelected: Point | Line | Polygon | undefined = useAppSelector(selectSyncGeometrySelected);
  const [arrayImages, setArrayImages] = useState([]);
  
  const handleOk = () => {
    dispatch(unselectSyncGeometry());
  };

  const handleCancel = () => {
    dispatch(unselectSyncGeometry());
  };

  const constructImagesPreview = async() =>{
      try {
        if((syncGeometrySelected?.adjuntos)){
            const objectImage = syncGeometrySelected?.adjuntos?.map(async(adjunto: Adjuntos)=>({
                image_full_size: await dispatch(getAdjuntoFullSize(adjunto.id)),
                image_thumbnail: await dispatch(getAdjuntoThumbnail(adjunto.id))
            }));
            return Promise.all(objectImage);
        }
      } catch (error) {
        console.log('Error', error);
      }
  }

  useEffect(() => {
    constructImagesPreview().then((value: any)=>{
        setArrayImages(value);
    });
  }, [syncGeometrySelected])

  const titleCustom = (type: string | undefined) =>{
    if(type){
        let title = '';
        switch (type) {
            case 'linea':
                title = 'Atributos de la Línea';
                break;
            case 'punto':
                title = 'Atributos de Punto';
                break;
            case 'poligono':
                title = 'Atributos del Polígono';
                break;
            default:
                break;
        }
        return title;
    }
  }

  const HeaderModal = () =>{
    return(
        <div className={'title-custom'}>
           {
               syncGeometrySelected?.tipo === 'linea' ?
               <SyncLine stroke = {syncGeometrySelected.color}/> : syncGeometrySelected?.tipo === 'poligono' ?
               <SyncPolygon stroke={syncGeometrySelected.color}/> : syncGeometrySelected?.tipo === 'punto' ?
               <SyncPoint fill={syncGeometrySelected.color}/> : null
           }
            <Text strong>{titleCustom(syncGeometrySelected?.tipo)}</Text> 
        </div>
    )
  }

  return (
    <div>
      <Row>
        <Col span={24}>
          <Modal
            title={<HeaderModal />}
            visible={!!syncGeometrySelected}
            onOk={handleOk}
            onCancel={handleCancel}
            okText={'Cerrar'}
            width={692}
            centered={true}
            className={'org-task__modal'}
            maskClosable={false}
            cancelButtonProps={{ style: { display: 'none' } }}
          >
            <Row gutter={24}>
                <Col xs={24} sm={24} md={10} lg={10}>
                <Row>
                    <div className={'container'}>
                    <Text strong>
                        Título
                    </Text>
                    <Text>
                        {syncGeometrySelected?.titulo}
                    </Text>
                    </div>
                </Row>
                <Row>
                    <div className={'container'}>
                    <Text strong>
                        Descripcion
                    </Text>
                    <Text>
                        {syncGeometrySelected?.descripcion ? truncateStringEllipsis(syncGeometrySelected?.descripcion, 215) : '-'}
                    </Text>
                    </div>
                </Row>
                {
                    syncGeometrySelected?.tipo === 'punto' ?
                    <div>
                        <Row>
                            <div className={'container'}>
                                <Text strong>
                                Categoria
                                </Text>
                                <Text>
                                {(syncGeometrySelected as Point)?.categoria ? getCategoriaPunto((syncGeometrySelected as Point).categoria) : '-'}
                                </Text>
                            </div>
                        </Row>
                        <Row>
                            <div className={'container'}>
                                <Text strong>
                                Numero de Acta
                                </Text>
                                <Text>
                                {(syncGeometrySelected as Point)?.numeroActa ? (syncGeometrySelected as Point)?.numeroActa : '-'}
                                </Text>
                            </div>
                        </Row>
                        <Row>
                            <div className={'container'}>
                                <Text strong>
                                Numero de expediente
                                </Text>
                                <Text>
                                {(syncGeometrySelected as Point)?.numExp ? (syncGeometrySelected as Point)?.numExp : '-'}
                                </Text>
                            </div>
                            </Row>
                    </div> : syncGeometrySelected?.tipo === 'poligono' ?
                    <div>
                        <Row>
                            <div className={'container'}>
                                <Text strong>
                                Area
                                </Text>
                                <Text>
                                {(syncGeometrySelected as Polygon)?.area ? (syncGeometrySelected as Polygon)?.area : '-'}
                                </Text>
                            </div>
                        </Row>
                        <Row>
                            <div className={'container'}>
                                <Text strong>
                                Perimetro
                                </Text>
                                <Text>
                                {(syncGeometrySelected as Polygon)?.perimetro ? (syncGeometrySelected as Polygon)?.perimetro : '-'}
                                </Text>
                            </div>
                        </Row>
                    </div> : syncGeometrySelected?.tipo === 'linea' ?
                    <div>
                        <Row>
                            <div className={'container'}>
                                <Text strong>
                                Distancia
                                </Text>
                                <Text>
                                {(syncGeometrySelected as Line)?.distancia ? (syncGeometrySelected as Line)?.distancia : '-'}
                                </Text>
                            </div>
                        </Row>
                        </div> : null
                }
                <Row>
                    <div className={'container'}>
                        <Text strong>
                        Creado por
                        </Text>
                        <div>
                            <Avatar
                            size={'large'}
                            style={{
                              color: '#FFFFFF',
                              backgroundColor: '#D9D9D9',
                            }}
                            >
                            {createInitialNames(syncGeometrySelected?.usuario?.nombre, syncGeometrySelected?.usuario?.apellido)}
                            </Avatar>
                            <Text style={{paddingLeft: 5}}>
                                {syncGeometrySelected?.usuario?.nombreCompleto}
                            </Text>
                        </div>
                        
                    </div>
                </Row>
                </Col>
                <Col xs={24} sm={24} md={10} lg={14}>
                <Row>
                    <div className={'container'}>
                        <Text strong>
                        Fecha de creación
                        </Text>
                        <Text>
                        {syncGeometrySelected?.fechaCreacion ? `${moment(syncGeometrySelected?.fechaCreacion).format('DD/MM/YYYY')} - ${moment(syncGeometrySelected?.fechaCreacion).format('HH:mm')}` : '-'}
                        </Text>
                    </div>
                </Row>
                {
                    syncGeometrySelected?.tipo === 'punto' ?
                    <div>
                        <Row>
                            <div className={'container'}>
                                <Text strong>
                                Coordenadas GPS
                                </Text>
                                <Text>
                                {`${syncGeometrySelected?.atributos?.gps?.latitud}  ${syncGeometrySelected?.atributos?.gps?.longitud}`}
                                </Text>
                            </div>
                        </Row>
                        <Row>
                            <div className={'container'}>
                                <Text strong>
                                Coordenadas Gauss-Kruger
                                </Text>
                                <Text>
                                X: {syncGeometrySelected.atributos?.gaussKruger?.coords[1]} m
                                </Text>
                                <Text>
                                Y: {syncGeometrySelected.atributos?.gaussKruger?.coords[0]} m
                                </Text>
                                <Text>
                                Faja {syncGeometrySelected.atributos?.gaussKruger?.faja} (EPSG: {syncGeometrySelected.atributos?.gaussKruger?.epsgCode})
                                </Text>
                            </div>
                        </Row>  
                    </div> : null
                }
                <Text strong>Imagenes Adjuntas</Text>
                {
                    arrayImages ?
                    (
                        <div className={'container-images'}>
                            <Image.PreviewGroup>
                                {
                                arrayImages && arrayImages.map((image: any, index)=>(
                                    <div className={'container-image'}>
                                        <Image
                                        src={image.image_thumbnail.payload.data}
                                        preview={{
                                          src: image.image_full_size.payload.data
                                        }}
                                        key={index}
                                    />
                                    </div>
                                ))
                                }
                            </Image.PreviewGroup>
                        </div>
                    )
                    :
                    <div className='tp-task-map__form__loading'>
                        <Spin indicator={<LoadingOutlined spin />} />
                    </div>
                }   
                </Col>    
            </Row>
          </Modal>
        </Col>
      </Row>
    </div>
  );
}

export default SyncTaskPopup;
